(function () {
  const dialog = document.getElementById("formDialog");
  const form = document.getElementById("entityForm");
  const fieldsRoot = document.getElementById("formFields");
  const confirmDialog = document.getElementById("confirmDialog");
  let submitHandler = null;
  let deleteHandler = null;

  function inputMarkup(field) {
    const required = field.required === false ? "" : "required";
    if (field.type === "textarea") return `<label>${field.label}<textarea name="${field.name}" ${required}>${escapeHtml(field.value || "")}</textarea></label>`;
    if (field.type === "select") return `<label>${field.label}<select name="${field.name}" ${required}>${field.options.map(option => `<option value="${escapeHtml(option.value)}" ${String(option.value) === String(field.value || "") ? "selected" : ""}>${escapeHtml(option.label)}</option>`).join("")}</select></label>`;
    if (field.type === "file") return `<label>${field.label}<input type="file" name="${field.name}" accept="image/*"><small>PNG, JPG atau WEBP. Pratonton disimpan pada peranti ini.</small><img id="coverPreview" class="upload-preview" src="${field.value || ""}" alt="Pratonton kulit buku" ${field.value ? "" : "hidden"}></label>`;
    return `<label>${field.label}<input type="${field.type || "text"}" name="${field.name}" value="${escapeHtml(field.value || "")}" ${required} placeholder="${field.placeholder || ""}"></label>`;
  }

  function escapeHtml(value) { const el = document.createElement("div"); el.textContent = value; return el.innerHTML; }
  function uid(prefix) { return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`; }

  window.PIBAdmin = {
    uid,
    openForm({ title, fields, onSubmit }) {
      document.getElementById("formTitle").textContent = title;
      fieldsRoot.innerHTML = fields.map(inputMarkup).join("");
      submitHandler = onSubmit;
      const file = form.querySelector('input[type="file"]');
      if (file) file.addEventListener("change", () => {
        const selected = file.files[0]; if (!selected) return;
        const reader = new FileReader();
        reader.onload = async () => { const preview = document.getElementById("coverPreview"); preview.src = await PIBStorage.compressImage(reader.result); preview.hidden = false; };
        reader.readAsDataURL(selected);
      });
      dialog.showModal();
    },
    confirm(message, onDelete) {
      document.getElementById("confirmMessage").textContent = message;
      deleteHandler = onDelete; confirmDialog.showModal();
    }
  };

  form.addEventListener("submit", event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(form).entries());
    const preview = document.getElementById("coverPreview");
    if (preview?.src && preview.src !== location.href) values.cover = preview.src;
    submitHandler?.(values); dialog.close();
  });
  document.querySelectorAll("[data-close]").forEach(button => button.addEventListener("click", () => dialog.close()));
  document.querySelector("[data-confirm-cancel]").addEventListener("click", () => confirmDialog.close());
  document.querySelector("[data-confirm-ok]").addEventListener("click", () => { deleteHandler?.(); confirmDialog.close(); });
})();
